<template>
    <div class="departureList">
        <!-- <div class="menuCont">
            <el-scrollbar style="height:100%">
                <el-menu
                    background-color="#ffffff"
                    unique-opened="true"
                    :default-active="defaultActive"
                    @select="handleSelect"
                >
                    <template v-for="item in menuList">
                        <el-menu-item
                            v-if="!item.child"
                            :key="item.id"
                            :index="item.id"
                        >
                            <i :class="['iconfont',item.icon]"></i>
                            <span slot="title">{{ item.name }}</span>
                            <span slot="title" class="num">
                                {{
                                    item.user_num !== 0 ? item.user_num : ""
                                }}</span
                            >
                        </el-menu-item>
                        <el-submenu v-else :key="item.id" :index="item.id">
                            <template slot="title">
                                <i :class="['iconfont','icon-yuan']"></i>
                                <span>{{ item.name }}</span>
                                <span slot="title">{{
                                    item.user_num !== 0 ? item.user_num : ""
                                }}</span>
                            </template>
                            <template v-for="second in item.child">
                                <el-menu-item
                                    ref
                                    v-if="!second.child"
                                    :key="second.id"
                                    :index="second.id"
                                    style="padding-left:60px;"
                                >
                                    <span slot="title">{{ second.name }}</span>
                                    <span slot="title" class="num">{{
                                        item.user_num !== 0 ? item.user_num : ""
                                    }}</span>
                                </el-menu-item>
                                <el-submenu
                                    v-else
                                    :key="second.id"
                                    :index="second.url"
                                >
                                    <template slot="title">{{
                                        second.name
                                    }}</template>
                                    <el-menu-item
                                        :index="third.id"
                                        v-for="third in second.child"
                                        :key="third.id"
                                        >{{ third.name }}</el-menu-item
                                    >
                                </el-submenu>
                            </template>
                        </el-submenu>
                    </template>
                </el-menu>
            </el-scrollbar>
        </div> -->
        <div class="tableCont">
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                    >
                        <el-form-item label="员工姓名" size="small">
                            <el-input
                                clearable
                                placeholder="请输入员工姓名"
                                size="small"
                                v-model="searchForm.name"
                                @keydown.enter.native="userGet"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" size="small">
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                size="small"
                                v-model.number="searchForm.phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @keydown.enter.native="userGet"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="所在部门" size="small">
                            <selectbutton
                                :props="props"
                                :options="optionData"
                                :value="menuId"
                                :clearable="isClearable"
                                :accordion="isAccordion"
                                @getValue="getValue($event)"
                                height="200"
                                ref="selectBtn"
                                placeholder="请选择所在部门"
                            ></selectbutton>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                            >
                                重置条件
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="userGet(1)"
                    >
                        查询
                    </el-button>
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                        @keydown.enter.native="userGet"
                    >
                        <el-form-item label="员工姓名" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入员工姓名"
                                size="mini"
                                v-model="searchForm.name"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                size="mini"
                                v-model.number="searchForm.phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @keydown.enter.native="userGet"
                            >
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="userGet(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth.slice(0, 2)">
                            <el-button
                                type="primary"
                                :key="item.id"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                        <el-dropdown
                            v-if="menuAuth.length > 2"
                            @command="authFunc"
                            style="margin-left: 10px"
                        >
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-arrow-down"
                            >
                                更多操作
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :key="item.id"
                                    v-for="item in menuAuth.slice(2)"
                                    :command="item.funcName"
                                >
                                    <i :class="item.icon"> </i>
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-else></div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>

            <div class="table" :style="{ height: screen }">
                <el-table
                    :data="tableData"
                    ref="tableData"
                    v-loading="loading"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                    @sort-change="sortChange"
                >
                    <el-table-column
                        type="selection"
                        align="left"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="工号"
                        property="job_no"
                        align="center"
                        width="80"
                    >
                    </el-table-column>
                  <el-table-column
                      label="员工姓名"
                      property="name"
                      align="left"
                  >
                    <template slot-scope="scope">
                      <div class="nameCont">
                        <div class="headImg" >
                          <el-avatar v-if="scope.row.avatar!=''"
                                     size="small"
                                     :src="scope.row.avatar"
                          ></el-avatar>
                          <span v-else>
                    <el-avatar
                        size="small"
                        :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.name)+'/avatar/50'"
                    ></el-avatar></span>

                        </div>
                        <div class="memberName">
                          {{ scope.row.name }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                    <el-table-column
                        label="联系电话"
                        property="phone"
                        width="120"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="性别"
                        property="sex_cn"
                        align="left"
                        width="60"
                    ></el-table-column>
                    <el-table-column
                        label="所属部门"
                        property="depart_name"
                        align="left"
                        width="200"
                    ></el-table-column>
                    <el-table-column
                        label="职位"
                        property="role_name"
                        align="left"
                    ></el-table-column>
                    <el-table-column label="是否已婚" align="left">
                        <template slot-scope="scope">
                            {{ scope.row.marriage == 0 ? "未婚" : "已婚" }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="学历"
                        align="left"
                        prop="education"
                    >
                    </el-table-column>
                    <el-table-column
                        label="籍贯"
                        align="left"
                        prop="hometown"
                    >
                    </el-table-column>
                    <el-table-column
                        label="入职日期"
                        property="entry_date"
                        width="120"
                        align="left"
                        :default-sort="{ prop: 'orderby_entry', order: null }"
                        sortable="custom"
                    ></el-table-column>
                    <el-table-column
                        label="离职时间"
                        property="resign_date"
                        align="left"
                        :default-sort="{ prop: 'orderby_resign_date', order: null }"
                        sortable="custom"
                    ></el-table-column>
                    <el-table-column
                        label="在职天数"
                        property="work_age"
                        width="120"
                        align="left"
                        :default-sort="{ prop: 'orderby_workday', order: null }"
                        sortable="custom"
                    >
                    </el-table-column>
                    <!-- <el-table-column label="当前状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                      :type="scope.row.resign_date == null ?'':'danger'">
                {{scope.row.resign_date ? '离职':'在职'}}
              </el-tag>
            </template>
          </el-table-column> -->
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <el-popconfirm
                                        v-else
                                        :title="'确定' + item.name + '?'"
                                        @onConfirm="rowDo(scope.row, item)"
                                    >
                                        <el-button
                                            slot="reference"
                                            type="text"
                                            size="small"
                                            :class="
                                                item.name == '删除'
                                                    ? 'redText'
                                                    : ''
                                            "
                                            >{{ item.name }}</el-button
                                        >
                                    </el-popconfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>
        </div>

        <StaffRecordDetail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></StaffRecordDetail>
        <StaffRecordEdit
            :edVisible.sync="edVisible"
            :tableItem.sync="tableItem"
        ></StaffRecordEdit>
    </div>
</template>
<script>
import { tableMixin } from "@/utils/tableMixins.js";
import StaffRecordDetail from "./staffRecord/detail";
import StaffRecordEdit from "./staffRecord/edit";
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import pagination from "@/comon/components/pagination";
import selectbutton from "@/comon/components/selectbutton";
import advancedSearch from "@/comon/components/advancedSearch";

export default {
    mixins: [tableMixin],
    data() {
        return {
            menuList: [],
            defaultActive: 0,
            searchForm: {
                name: "",
                phone: "",
                status: 10,
            },
            menuId: "",
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            tableItem: [],
            detailVisible: false,
            addVisible: false,
            passwordVisible: false,
            edVisible: false,
            passwordForm: {
                password: "",
                passwordAgain: "",
            },
            rowId: "",
            bulkVisible: false,
            errArray: [],
            success_num: 0,
            failure_num: 0,

            statusList: [
                { status: "", name: "请选择" },
                { status: 1, name: "在职" },
                { status: 10, name: "离职" },
            ],

            selectionUserIdList: [],
            setRoleVisible: false,
            setRoleloading: false,
            typeList: [],
            roleId: 4,
            searchFormH: "",
            orderby_entry: null,
            orderby_resign_date: 'desc',
            orderby_workday: null,

            isClearable: false, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            valueId: "", // 初始ID（可选）
            props: {
                // 配置项（必选）
                value: "id",
                label: "name",
                children: "child",
                // disabled: true
            },
            // 选项列表（必选）
            list: [],

            drawerVisible: false,
        };
    },
    methods: {
        // 取值
        getValue(value) {
            if (value) {
                this.menuId = value.id;
            } else {
                this.menuId = "";
            }
        },
        detail(row) {
            this.tableItem = row;
            this.detailVisible = true;
        },
        add() {
            this.addVisible = true;
        },
        /**
         *  获取组织架构信息
         */
        depart() {
            api.depart({}, "get").then((res) => {
                if (res) {
                    this.list = res.data;
                }
            });
        },
        /**
         * 菜单选择
         */
        handleSelect(val) {
            this.searchForm = {
                name: "",
                phone: "",
            };
            this.page = 1;
            this.perPage = 10;
            this.menuId = val;
            this.userGet();
        },
        /**
         * 获取员工列表
         */
        userGet(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .user(
                    {
                        depart_id: this.menuId,
                        ...this.paginationData,
                        ...this.searchForm,
                        status: 10,
                        orderby_entry: this.orderby_entry,
                        orderby_resign_date: this.orderby_resign_date,
                        orderby_workday: this.orderby_workday,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                        this.drawerVisible = false;
                    }
                });
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "查看") {
                this.detail(row);
            } else if (item.name == "编辑") {
                this.edit(row);
            }
        },
        // 回车事件
        enterKeyUp(e) {
            let key = window.event.keyCode || e.keyCode;
            if (key === 13) {
                this.userGet(1);
            }
        },
        /**
         * table内编辑
         */
        edit(row) {
            this.tableItem = row;
            this.edVisible = true;
        },
        /**
         * 重置密码
         */
        resetPwd(row) {
            this.rowId = row.id;
            this.passwordVisible = true;
        },
        /**
         * 修改密码弹窗 关闭事件
         */
        closePwdDialog() {
            this.passwordForm = {
                password: "",
                passwordAgain: "",
            };
            this.$refs["passwordForm"].resetFields();
            this.$refs["passwordForm"].clearValidate();
        },
        /**
         * 修改密码提交
         */
        changeUserPwd() {
            this.pwdloading = true;
            this.$refs["passwordForm"].validate((valid) => {
                if (valid) {
                    if (
                        this.passwordForm.password ==
                        this.passwordForm.passwordAgain
                    ) {
                        oaApi
                            .changeUserPwd(
                                {
                                    password: this.passwordForm.password,
                                    user_id: this.rowId,
                                },
                                "post"
                            )
                            .then((res) => {
                                this.pwdloading = false;
                                this.passwordVisible = false;
                                if (res.code == 200) {
                                    this.$message.success("修改成功");
                                }
                            });
                    } else {
                        this.$message.error("两次输入的密码不同");
                    }
                }
            });
        },
        bulkImport() {
            this.bulkVisible = true;
        },
        authFunc(funcName) {
            this[funcName]();
        },
        userExport() {
            oaApi
                .userExport(
                    {
                        depart_id: this.menuId,
                        status: 10,
                        selectList: this.selectionUserIdList,
                        ...this.searchForm,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        window.open(res.data.url);
                    }
                });
        },
        setRole() {
            this.getRoleList();
            if (this.selectionUserIdList.length) {
                this.setRoleVisible = true;
            } else {
                this.$message.error("请选择员工后操作");
            }
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
        closeSetRoleDialog() {
            this.roleId = 4;
        },
        setRoleSave() {
            oaApi
                .userSetRole(
                    {
                        userId: this.selectionUserIdList,
                        roleId: this.roleId,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success("设置成功");
                            this.userGet();
                        }
                        this.setRoleVisible = false;
                    }
                });
        },
        getRoleList() {
            oaApi.role({}, "get").then((res) => {
                if (res) {
                    this.typeList = res.data;
                }
            });
        },
        /**
         * 列表筛选
         */
        sortChange(column) {
            this.orderby_entry = null;
            this.orderby_workday = null;
            this.orderby_resign_date = null;
            if (column.prop == "entry_date") {
                if (column.order == "descending") {
                    this.orderby_entry = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_entry = "asc";
                }
            }
            if (column.prop == "work_age") {
                if (column.order == "descending") {
                    this.orderby_workday = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_workday = "asc";
                }
            }
          if (column.prop == "resign_date") {
            if (column.order == "descending") {
              this.orderby_resign_date = "desc";
            } else if (column.order == "ascending") {
              this.orderby_resign_date = "asc";
            }
          }
            this.userGet();
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.userGet();
        },
        clean() {
            this.searchForm = {
                name: "",
                phone: "",
                status: 10,
            };
            //   this.menuId = ;
            if (this.$refs.selectBtn) {
                this.$refs.selectBtn.clearHandle();
            }
        },
    },
    created() {
        this.depart();
        this.userGet();
    },

    components: {
        StaffRecordDetail: StaffRecordDetail,
        pagination: pagination,
        StaffRecordEdit: StaffRecordEdit,
        selectbutton: selectbutton,
        advancedSearch: advancedSearch,
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.userGet();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.userGet();
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        screen() {
            return `calc(100% - 40px - 40px)`;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
        /* 转树形数据 */
        optionData() {
            let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
            return cloneData.filter((father) => {
                // 循环所有项，并添加children属性
                let branchArr = cloneData.filter(
                    (child) => father.id == child.parent_id
                ); // 返回每一项的子级数组
                branchArr.length > 0 ? (father.child = branchArr) : ""; //给父级添加一个children属性，并赋值
                return father.parent_id == 0; //返回第一层
            });
        },
    },
};
</script>
<style lang="scss">
.departureList {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    // .menuCont {
    //     width: 250px;
    //     // border-right: 1px #eee solid;
    //     height: 100%;
    //     .el-scrollbar__wrap {
    //         overflow-x: hidden;
    //     }
    //     .staffMenu {
    //         background: #fff !important;
    //         color: #fff !important;
    //     }
    //     .el-menu-item {
    //         background: #fff !important;
    //         text-align: left;
    //         i {
    //             color: #222222;
    //             padding-right: 10px;
    //         }
    //     }
    //     .el-submenu {
    //         text-align: left;
    //     }
    //     .el-submenu__title {
    //         background: #fff !important;
    //         i {
    //             color: #222222;
    //             padding-right: 10px;
    //         }
    //     }
    //     .el-submenu .el-menu-item {
    //         background: #fff !important;
    //     }
    //     .el-menu-item.is-active {
    //         background: #e6f7ff !important;
    //         border-right: 2px #1890ff solid;
    //         i {
    //             color: #1890ff !important;
    //         }
    //     }
    // }
    .tableCont {
        // width: calc(100% - 250px);
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            // padding: 0 20px;
            // .el-scrollbar__wrap {
            //     overflow-x: hidden;
            // }
            .nameCont {
                display: flex;
                align-items: center;
                justify-content: start;
              .headImg {
                height: 28px;
                width: 28px;
                border-radius: 8px;
                overflow: hidden;
                margin-right: 8px;
                justify-items: flex-start;
                img{
                  width: 100%;
                }
              }
                .memberName {
                    line-height: 24px;
                }
            }
        }
    }
    .bulkImport {
        .bulkText {
            text-align: left;
        }
        .condition {
            width: 100%;
            li {
                text-align: left;
                line-height: 2;
            }
        }
    }
    // .el-scrollbar__wrap {
    //     overflow-x: hidden;
    // }
}
</style>
